<template>
  <div class="forecast-section" v-show="getShowWidget()">
    <div class="section-title">Aktualna pogoda - {{ getWName() }}</div>
    <div class="forecast">
      <div class="forecast__today">
        <div class="mb-12">
          Dzisiaj, <span class="font-m">{{ getWeatherDay(0) }}</span>
        </div>
        <div class="forecast__details">
          <div class="forecast__main">
            <div class="forecast__icon">
              <span class="svg-icon d-inline-flex" aria-hidden="true">
                <svg
                  class="svg-icon__svg"
                  width="70px"
                  height="70px"
                  focusable="false"
                >
                  <use
                    :xlink:href="
                      `/img/static/svg-weather-sprites.svg#` +
                        getCurrentMeteoIcon()
                    "
                  ></use>
                </svg>
              </span>
            </div>
            <div class="forecast__temp">
              <span>{{ getCurrentTemp() }} &#176;C</span>
            </div>
          </div>
          <div class="forecast__conditions">
            <div class="forecast__conditions-line">
              <span class="gray-60">Opady:</span>
              <span>{{ getCurrentPrecipitation() }}</span>
            </div>
            <div class="forecast__conditions-line">
              <span class="gray-60">Wiatr:</span>
              <span
                >{{ getCurrentWindSpeed() }} km/h
                <a-icon
                  :style="{
                    transform:
                      'rotate(' + getWeatherCurrentWindDegree() + 'deg)'
                  }"
                  type="arrow-up"
                  class="c-blue-light"
                />
              </span>
            </div>
            <div class="forecast__conditions-line">
              <span class="gray-60">Ciśnienie:</span>
              <span>{{ getCurrentPressure() }}</span>
            </div>
            <div class="forecast__conditions-line">
              <span class="gray-60">Zachmurzenie:</span>
              <span>{{ getCurrentCloudcover() }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="forecast__next">
        <div class="forecast__next-track custom-scrollbar">
          <div
            v-for="(item, idx) in forecastNextDaysData"
            :key="idx"
            class="forecast__next-item"
          >
            <div class="forecast__next-day mb-8">
              <span class="d-block">{{ item.dayName }}</span>
              <span class="d-block font-m">{{ item.date }}</span>
            </div>
            <div class="forecast__next-main">
              <div class="forecast__next-icon">
                <span class="svg-icon d-inline-flex" aria-hidden="true">
                  <svg
                    class="svg-icon__svg"
                    width="56px"
                    height="56px"
                    focusable="false"
                  >
                    <use
                      :xlink:href="
                        `/img/static/svg-weather-sprites.svg#` + item.icon
                      "
                    ></use>
                  </svg>
                </span>
              </div>
              <div class="forecast__next-temp font-m">
                <span>{{ item.tempMin }}-{{ item.tempMax }} &#176;C</span>
              </div>
            </div>
            <div
              class="forecast__next-conditions-wrapper"
              :class="{ _visible: fullweather }"
            >
              <div class="forecast__next-conditions">
                <div class="forecast__next-conditions-line">
                  <span class="gray-60">Opady:</span>
                  <span>{{ item.precip }}</span>
                </div>
                <div class="forecast__next-conditions-line">
                  <span class="gray-60">Wiatr:</span>
                  <span
                    >{{ item.windSpeed }} km/h
                    <a-icon
                      :style="{
                        transform: 'rotate(' + item.windDegree + 'deg)'
                      }"
                      type="arrow-up"
                      class="c-blue-light"
                    />
                  </span>
                </div>
                <div class="forecast__next-conditions-line">
                  <span class="gray-60">Wschód:</span>
                  <span>{{ item.sunrise }}</span>
                </div>
                <div class="forecast__next-conditions-line">
                  <span class="gray-60">Zachód:</span>
                  <span>{{ item.sunset }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="forecast__next-expand">
        <span @click="showForecast()"
          >{{ fullweathertxt }} szczegóły pogody</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import * as CONFIG from "../config.js";
import * as GEOSTRUCTURE from "../../../geotree.js";

export default {
  props: {
    wname: String,
    hlocid: String
  },
  data: () => ({
    url: "/getprzewodnikmeteo.json",
    meteo: {},
    forecastNextDaysData: [],
    geostruct: GEOSTRUCTURE.geostruktura,
    locid: "",
    countrylocid: CONFIG.locid,
    serwis: CONFIG.serwis,
    fullweather: false,
    fullweathertxt: "pokaż",
    showWidget: true
  }),
  methods: {
    getShowWidget() {
      return this.showWidget;
    },
    hideWidget() {
      this.showWidget = false;
    },
    getWName() {
      if (this.meteo && this.meteo.nazwa && this.meteo.nazwa != "") {
        return this.meteo.nazwa;
      } else {
        return this.wname;
      }
    },
    showForecast() {
      this.fullweather = !this.fullweather;
      if (!this.fullweather) {
        this.fullweathertxt = "pokaż";
      } else {
        this.fullweathertxt = "ukryj";
      }
    },
    getGeoMeteo() {
      var pars = "locid=" + this.locid;
      return axios
        .get(CONFIG.API_URL + this.url + "?" + pars, null, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: "application/json"
          }
        })
        .then(response => {
          return response.data;
        })
        .catch(e => {
          alert("ERROR" + e);
        });
    },
    getWeatherDay(i) {
      if (
        this.meteo.dni &&
        this.meteo.dni.dzien[i] &&
        this.meteo.dni.dzien[i].data
      ) {
        return this.meteo.dni.dzien[i].data;
      } else {
        return "";
      }
    },
    getWeatherDayName(i) {
      if (
        this.meteo.dni &&
        this.meteo.dni.dzien[i] &&
        this.meteo.dni.dzien[i]["dzien-tygodnia"]
      ) {
        return this.meteo.dni.dzien[i]["dzien-tygodnia"];
      } else {
        return "";
      }
    },
    getWeatherTempMinC(i) {
      if (
        this.meteo.data &&
        this.meteo.data.weather[i] &&
        this.meteo.data.weather[i].tempMinC
      ) {
        return this.meteo.data.weather[i].tempMinC;
      } else {
        return "";
      }
    },
    getWeatherTempMaxC(i) {
      if (
        this.meteo.data &&
        this.meteo.data.weather[i] &&
        this.meteo.data.weather[i].tempMaxC
      ) {
        return this.meteo.data.weather[i].tempMaxC;
      } else {
        return "";
      }
    },
    getCurrentTemp() {
      if (
        this.meteo.data &&
        this.meteo.data.current_condition &&
        this.meteo.data.current_condition.temp_C
      ) {
        return this.meteo.data.current_condition.temp_C;
      } else {
        return "";
      }
    },
    getCurrentWindSpeed() {
      if (
        this.meteo.data &&
        this.meteo.data.current_condition &&
        this.meteo.data.current_condition.windspeedKmph
      ) {
        return this.meteo.data.current_condition.windspeedKmph;
      } else {
        return "";
      }
    },
    getWeatherWindSpeed(i) {
      if (
        this.meteo.data &&
        this.meteo.data.weather[i] &&
        this.meteo.data.weather[i].windspeedKmph
      ) {
        return this.meteo.data.weather[i].windspeedKmph;
      } else {
        return "";
      }
    },
    getWeatherCurrentWindDegree() {
      if (
        this.meteo.data &&
        this.meteo.data.current_condition &&
        this.meteo.data.current_condition.winddirDegree
      ) {
        return this.meteo.data.current_condition.winddirDegree;
      } else {
        return "";
      }
    },
    getWeatherWindDegree(i) {
      if (
        this.meteo.data &&
        this.meteo.data.weather[i] &&
        this.meteo.data.weather[i].winddirDegree
      ) {
        return this.meteo.data.weather[i].winddirDegree;
      } else {
        return "";
      }
    },
    getCurrentPrecipitation() {
      if (
        this.meteo.data &&
        this.meteo.data.current_condition &&
        this.meteo.data.current_condition.precipMM
      ) {
        if (this.meteo.data.current_condition.precipMM == 0) {
          return "brak";
        } else {
          return this.meteo.data.current_condition.precipMM + " mm";
        }
      } else {
        return "";
      }
    },
    getWeatherPrecipitation(i) {
      if (
        this.meteo.data &&
        this.meteo.data.weather[i] &&
        this.meteo.data.weather[i].precipMM
      ) {
        if (this.meteo.data.weather[i].precipMM == 0) {
          return "brak";
        } else {
          return this.meteo.data.weather[i].precipMM + " mm";
        }
      } else {
        return "";
      }
    },
    getCurrentPressure() {
      if (
        this.meteo.data &&
        this.meteo.data.current_condition &&
        this.meteo.data.current_condition.pressure
      ) {
        if (this.meteo.data.current_condition.pressure == 0) {
          return "b.d.";
        } else {
          return this.meteo.data.current_condition.pressure + " hPa";
        }
      } else {
        return "";
      }
    },
    getCurrentCloudcover() {
      if (
        this.meteo.data &&
        this.meteo.data.current_condition &&
        this.meteo.data.current_condition.cloudcover
      ) {
        if (this.meteo.data.current_condition.cloudcover == 0) {
          return "brak";
        } else {
          return this.meteo.data.current_condition.cloudcover + " %";
        }
      } else {
        return "";
      }
    },
    getSunriseTime(i) {
      if (
        this.meteo.dni &&
        this.meteo.dni.dzien[i] &&
        this.meteo.dni.dzien[i].wschod
      ) {
        return this.meteo.dni.dzien[i].wschod;
      } else {
        return "";
      }
    },
    getSunsetTime(i) {
      if (
        this.meteo.dni &&
        this.meteo.dni.dzien[i] &&
        this.meteo.dni.dzien[i].zachod
      ) {
        return this.meteo.dni.dzien[i].zachod;
      } else {
        return "";
      }
    },
    getCurrentMeteoIcon() {
      if (
        this.meteo.data &&
        this.meteo.data.current_condition &&
        this.meteo.data.current_condition.weatherIconUrl
      ) {
        return this.getImageName(
          this.meteo.data.current_condition.weatherIconUrl
        );
      } else {
        return "";
      }
    },
    getMeteoIcon(i) {
      if (
        this.meteo.data &&
        this.meteo.data.weather[i] &&
        this.meteo.data.weather[i].weatherIconUrl
      ) {
        return this.getImageName(this.meteo.data.weather[i].weatherIconUrl);
      } else {
        return "";
      }
    },
    getImageName(imageUrl) {
      if (imageUrl) {
        return imageUrl
          .split("\\")
          .pop()
          .split("/")
          .pop()
          .split(".")[0];
      } else {
        return "";
      }
    },
    getForecastNextDays() {
      let forecastDays = [];

      if (this.meteo && this.meteo.data && this.meteo.data.weather) {
        for (let i = 1; i <= this.meteo.data.weather.length - 1; i++) {
          forecastDays.push({
            date: this.getWeatherDay(i),
            dayName: this.getWeatherDayName(i),
            icon: this.getMeteoIcon(i),
            tempMin: this.getWeatherTempMinC(i),
            tempMax: this.getWeatherTempMaxC(i),
            precip: this.getWeatherPrecipitation(i),
            windSpeed: this.getWeatherWindSpeed(i),
            windDegree: this.getWeatherWindDegree(i),
            sunrise: this.getSunriseTime(i),
            sunset: this.getSunsetTime(i)
          });
        }
      }
      this.forecastNextDaysData = forecastDays;
    }
  },
  mounted() {
    if (this.hlocid != null && this.hlocid != "") {
      this.locid = this.hlocid;
    }
    let path = decodeURIComponent(this.$route.fullPath);
    var locid = getLocidFromUrl(path, this.geostruct.geotree);
    if (locid != "") {
      this.locid = locid;
    }
    if (this.locid == "") {
      this.locid = this.countrylocid;
    }
    this.getGeoMeteo().then(data => {
      this.meteo = data.Meteo;
      if (this.meteo && this.meteo.data && this.meteo.data.weather) {
        let climateLocid = this.meteo.locid;
        this.$root.$emit("update:climateLocid", climateLocid);
        this.getForecastNextDays();
      } else {
        this.hideWidget();
      }
    });
  }
};

function getLocidFromUrl(path, geotree) {
  if (geotree.Country.url == path) {
    return geotree.Country.locID;
  }
  for (var i = 0; i < geotree.Country.Region.length; i++) {
    var elem = geotree.Country.Region[i];
    if (elem.url == path) {
      return elem.locID;
    }
    if (elem.Miniregion) {
      for (var j = 0; j < elem.Miniregion.length; j++) {
        var elem2 = elem.Miniregion[j];
        if (elem2.url == path) {
          return elem2.locID;
        }
      }
    }
  }
  return "";
}
</script>

<style lang="scss" scoped>
.section-title {
  @include text-truncate();
  @include font-m();
  font-size: 20px;
  margin-bottom: 18px;
}

.forecast-section {
  margin-bottom: 32px;

  .forecast {
    &__today {
      border-bottom: 1px solid $border-color;
      padding-bottom: 24px;
      margin-bottom: 24px;
    }

    &__details {
      display: flex;

      @media (max-width: $screen-xxs-max) {
        justify-content: space-around;
      }

      @media (min-width: $screen-xs) {
        justify-content: space-between;
      }
    }

    &__main {
      @media (max-width: $screen-xxs-max) {
        margin-right: 24px;
        text-align: center;
      }

      @media (min-width: $screen-xs) {
        display: flex;
        align-items: center;
      }
    }

    &__icon {
      @media (max-width: $screen-xxs-max) {
        margin-bottom: 8px;
      }

      @media (min-width: $screen-xs) {
        margin-right: 24px;
      }
    }

    &__temp {
      > span {
        display: block;
        font-size: 30px;
        line-height: 0.95;
        white-space: nowrap;
      }
    }

    &__conditions {
      display: flex;
      flex-wrap: wrap;

      @media (max-width: $screen-xxs-max) {
        flex: 0 0 50%;
        max-width: 240px;
      }

      @media (min-width: $screen-xs) {
        margin: auto 0 auto auto;
      }
    }

    &__conditions-line {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      white-space: nowrap;
      width: 100%;

      @media (min-width: $screen-xs) {
        margin-left: auto;
        width: 42%;
        font-size: 16px;
      }
    }

    &__next {
      &-item {
        margin-bottom: 18px;
        min-width: 180px;
        padding-right: 18px;
        width: 25%;
        backface-visibility: hidden;
        transform: translateZ(0);
      }

      &-main {
        display: flex;
        align-items: center;
      }

      &-icon {
        margin-right: 18px;
      }

      &-temp {
        font-size: 18px;
        white-space: nowrap;
      }

      &-conditions-wrapper {
        max-height: 0;
        opacity: 0;
        overflow: hidden;
        transition: all linear 0.135s;

        &._visible {
          max-height: 200px;
          opacity: 1;
        }
      }

      &-conditions {
        padding-top: 24px;
      }

      &-conditions-line {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        white-space: nowrap;
        width: 100%;

        &:not(:last-of-type) {
          margin-bottom: 4px;
        }
      }

      &-track {
        border-bottom: 1px solid $border-color;
        display: flex;
        margin-bottom: 12px;
        overflow-y: auto;
      }

      &-expand {
        > span {
          color: $blue-light;
          cursor: pointer;
        }

        display: flex;
        justify-content: flex-end;
      }
    }
  }
}

.custom-scrollbar {
  scrollbar-width: thin;

  &::-webkit-scrollbar,
  &::-webkit-scrollbar-track,
  &::-webkit-scrollbar-thumb {
    border-radius: 2px;
  }

  &::-webkit-scrollbar {
    height: 6px;
  }

  &::-webkit-scrollbar-track {
    background-color: lighten($gray-20, 7%);
  }

  &::-webkit-scrollbar-thumb {
    background-color: darken($gray-20, 5%);
  }
}
</style>
